import React from 'react';

interface ErrorMessageProps {
  error: string;
}

const ErrorMess: React.FC<ErrorMessageProps> = ({ error }) => {
  return (
    <div className=' font-semibold'>
      <p className='text-[#D04D4D] bg-[#FFEBEB] py-4 pl-7 '>{error}</p>
    </div>
  );
};

export default ErrorMess;
